import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WatchOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"watch_off"}/>
}
